export enum TimeZone {
  Jerusalem = 'Asia/Jerusalem',
  Kyiv = 'Europe/Kyiv',
  Nasdaq = 'America/New_York',
  UTC = 'UTC',
}

export const DEFAULT_TIME_ZONE = TimeZone.Jerusalem;
